import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { Capacitor } from "@capacitor/core";
import { COOKIE_OPTIONS_SUFFIX } from "./cookieConfig";
import store from "../store";

/**
 * Normalize notification payload to the shape used for redirect: { link, project, eventName, eventCode, linkType, ... }.
 * Plugin may send { notification: { title, body, data } } or our Android plugin stores flat { title, body, link, project, ... }.
 */
function getRedirectPayload(notification) {
  if (!notification) return null;
  const n = notification.notification || notification;
  const data = n.data || n;
  const flat = data && typeof data === "object" && !Array.isArray(data) ? data : null;
  return flat && (flat.link != null || flat.project != null || flat.eventName != null) ? flat : null;
}

export default {
  data() {
    return {
      mobileToken: null,
      platform: Capacitor.getPlatform(),
    };
  },
  methods: {
    /** Request notification permission and get FCM token. Call from LoginPage. */
    async registerFCM() {
      if (!Capacitor.isNativePlatform()) {
        console.log("Web environment detected, skipping FCM setup");
        return;
      }
      try {
        let permStatus = await FirebaseMessaging.checkPermissions();
        if (permStatus.receive === "prompt") {
          permStatus = await FirebaseMessaging.requestPermissions();
        }

        if (permStatus.receive !== "granted") {
          throw new Error("User denied notification permissions");
        }
        console.log("Permission granted ✅");
        const { token } = await FirebaseMessaging.getToken();
        this.mobileToken = token;
        document.cookie = `mobileToken=${JSON.stringify({ token: token, platform: Capacitor.getPlatform() })}; ${COOKIE_OPTIONS_SUFFIX}`;
      } catch (err) {
        console.error("Error during FCM setup:", err);
      }
    },

    /**
     * Add FCM listeners. Call from App.vue so notifications are handled app-wide.
     * - notificationReceived: only when app is in FOREGROUND and a push arrives; we store payload so UI can show/redirect.
     * - notificationActionPerformed: when user taps the notification. On Android we do NOT set store here because
     *   the tap is already handled by MainActivity → currentNotification → router. Setting here would duplicate
     *   and cause a second redirect. We only log for debugging.
     */
    async addNotificationListeners() {
      if (!Capacitor.isNativePlatform()) return;
      try {
        await FirebaseMessaging.addListener("notificationReceived", (notification) => {
          const payload = getRedirectPayload(notification);
          if (payload) store.commit("userVUEX/setNotificationRedirect", payload);
        });
        await FirebaseMessaging.addListener("notificationActionPerformed", () => {
          // Tap is handled by native: MainActivity writes currentNotification → router reads and redirects.
          // Do not set store here to avoid double redirect.
        });
      } catch (err) {
        console.error("Error adding notification listeners:", err);
      }
    },
  },
};
